<template>
  <div class="history-client--container no-select">

    <div class="mrg-t-10" v-if="modificationsList.length > 0">
      <div class="input-block">
        <label>Фильровать по модификации</label>
        <select v-model="filterByModification">
          <option value="0">Показывать всё</option>
          <option
            v-for="item in modificationsList"
            :key="item.id"
            :value="item.id"
          >{{ item.name }}</option>
        </select>
      </div>
    </div>

    <div class="mrg-t-10 mrg-b-10" v-if="unionList.length > 0">
      <div class="input-block">
        <label>Фильровать по объединенным клиентам</label>
        <select v-model="filterByUnion">
          <option value="0">Показывать записи всех</option>
          <option
            v-for="item in unionList"
            :key="item.id"
            :value="item.id"
          >{{ item.surname }} {{ item.name }} / +{{ item.number }}</option>
        </select>
      </div>
    </div>

    <only-labels
      @selectEnroll="selectEnroll"
      :data="data"
    ></only-labels>

    <div class="mrg-t-15 text-center">
      <div @click="loadMore" class="btn btn-sm btn-success">Загрузить еще...</div>
    </div>

    <popup
        :closeButton="editEnrollPopup.closeButton"
        :show="editEnrollPopup.show"
        :size="editEnrollPopup.size"
        :backgroundColor="editEnrollPopup.backgroundColor"
        @closePopup="closeEditEnrollPopup"
    >
      <div slot="header">{{ editEnrollPopup.header }}</div>
      <div slot="body">
        <fast-new
            :name="'history'"
            :loadEnrollId="selectedEnrollId"
            :default-date="fastNewDefaultDate"
            :want-time="wantTime"
            :show="editEnrollPopup.show"
            :mode="'edit'"
            @update="clearAndLoad"
            @close="closeEditEnrollPopup"
            @updateLoadEnroll="updateLoadEnroll"
        ></fast-new>
      </div>
    </popup>

  </div>
</template>

<script>
import Formatter from "@/components/libraries/Formatter";
const formatter = new Formatter();

import OnlyLabels from "@/components/panel/journal/OnlyLabels";
import Popup from "@/components/Popup";
import clientsRepository from "../../../repositories/clients";

export default {
  name: "HistoryClient",
  components: {
    OnlyLabels,
    Popup,
    FastNew: () => import('@/components/panel/journal/fast_new/FastNew')
  },
  data() {
    return {
      modificationsList: [],
      unionList: [],

      data: [],
      limit: 20,
      page: 0,

      lastSearchMode: null,
      resetSearchClient: 0,
      selectedEnrollId: null,
      fastNewDefaultDate: "",
      wantTime: 0,
      editEnrollPopup: {
        show: false,
        size: "lg",
        header: "",
        backgroundColor: 'wgray'
      },

      filterByModification: 0,
      filterByUnion: 0
    };
  },
  props: {
    id: Number // ID клиента для загрузки данных
  },
  watch: {
    id: function() {
      this.page = 0;
      this.loadData(this.filterByModification, this.filterByUnion);
      this.getRelations();
    },
    filterByModification: function(val){
      this.page = 0;
      this.loadData(val, this.filterByUnion);
    },
    filterByUnion: function(val){
      this.page = 0;
      this.loadData(this.filterByModification, val);
    }
  },
  computed: {},
  methods: {
    getRelations(){
      clientsRepository.getUnionForHistory({client_id: this.id}).then(resp => {
        this.unionList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    selectEnroll(enroll){
      this.selectedEnrollId = +enroll.id;
      this.fastNewDefaultDate = formatter.phpDateToRus(enroll.date);
      this.wantTime = +enroll.time;
      this.editEnrollPopup.show = true;
    },
    closeEditEnrollPopup(){
      this.editEnrollPopup.show = false;
      this.selectedEnrollId = 0;
    },
    updateLoadEnroll(val) {
      this.selectedEnrollId = val;
    },
    clearAndLoad(){
      this.page = 0;
      this.loadData(this.filterByModification, this.filterByUnion);
    },
    loadData(filterByModification, filterByUnion) {
      if (this.id !== null) {
        this.$store.dispatch("startPreloader");

        clientsRepository.getHistory({
          client_id: this.id,
          limit: this.limit,
          page: this.page,
          filter_by_modification: filterByModification,
          filter_by_union: filterByUnion
        }).then(resp => {
          if(this.page == 0){
            this.data = [];
          }
          if(!resp.data.length && this.data.length){
            this.$store.dispatch("addNotification", {
              text: 'Записей в истории больше нет',
              time: 3,
              color: "danger"
            });
          }
          for(let key in resp.data){
            this.data.push(resp.data[key]);
          }
          this.$store.dispatch("stopPreloader");
        }).catch(err => {
          this.$store.dispatch("addNotification", {
            text: err.response.data.message,
            time: 6,
            color: "danger"
          });
          this.$store.dispatch("stopPreloader");
        });
      }
    },
    loadMore(){
      this.page++;
      this.loadData(this.filterByModification, this.filterByUnion);
    }
  },
  created() {
    this.loadData(this.filterByModification, this.filterByUnion);
    this.getRelations();
  }
};
</script>

<style scoped lang="less"></style>
